export default "__VITE_ASSET__5JQZtFT8__"